export const FOLDER_DOCUMENTS = "/api/folder/:param/documents"
export const FOLDER_DOCUMENT = "/api/folder/:param/document/:documentParam"
